import graphql from "babel-plugin-relay/macro";

export default graphql`
  query importLogsQuery($propertyId: ID!) {
    importLogs(propertyId: $propertyId) {
      edges {
        node {
          id
          createdAt
          fileName
          importedAt
          importedBy
          totalRows
          successCount
          failureCount
          contactsBeforeLoad
          contactsAfterLoad
        }
      }
    }
  }
`;
